import Metatags from '../../../components/MetaTags/MetaTags';
import RegisterForm from './RegisterForm';
import useRegister from './useRegister';

export default function Register() {
  const {
    initialValues,
    auth,
    handleSubmit,
    handleBackToLogin,
    validationSchema,
    showPassword,
    setShowPassword,
  } = useRegister();

  return (
    <>
      <Metatags metaTagName="Register | ISV Insights" />
      <RegisterForm
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        handleBackToLogin={handleBackToLogin}
        auth={auth}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
      />
    </>
  );
}
